export const travelLineIntegrationSubmitButtonTeleport = 'travel-line-integration-submit-button';
export const tariffTabsAppendTeleport = 'tariff-tabs-append-teleport';
